import logo from './logo.svg';
import './App.css';
import { Box } from "@mui/material";
import Chat from "./components/Chat";

function App() {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5"
      }}
    >
      <Chat />
    </Box>
  );
}

export default App;
